module.exports = __webpack_public_path__ + "static/img/ad1.498f8720.png";